
import { FixStudentDuplicationsResponseItem } from "@/api/classroomTransfer";
import MBaseModal from "@/components/MBaseModal.vue";
import MButton from "@/components/MButton.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    MBaseModal,
    MButton
  },
  props: {
    results: { type: Array, required: true },
    schoolNameMap: { type: Object, required: true }
  },
  emits: ["close"]
})
export default class DuplicationResultModal extends Vue {
  results!: FixStudentDuplicationsResponseItem[];
  schoolNameMap!: Record<string, string>;

  getStatusLabel(status: string): string {
    switch (status) {
      case "success":
        return "全て成功";
      case "partial_failure":
        return "一部失敗";
      case "failure":
        return "全て失敗";
      case "no_duplicates":
        return "重複なし";
      default:
        return status;
    }
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case "success":
        return "bg-green-100 text-green-700";
      case "partial_failure":
        return "bg-yellow-100 text-yellow-700";
      case "failure":
        return "bg-red-100 text-red-700";
      case "no_duplicates":
        return "bg-gray-100 text-gray-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  }
}
